import { get, put, postForm } from './client';

export const buscarConfig = () => get('/config');

export const salvarNomeApp = (nomeApp) => put('/config', { nomeApp });

export const enviarFavicon = (arquivo) => {
  const fd = new FormData();
  fd.append('favicon', arquivo);
  return postForm('/config/favicon', fd);
};

export const enviarLogo = (arquivo) => {
  const fd = new FormData();
  fd.append('logo', arquivo);
  return postForm('/config/logo', fd);
};
